import { activePlaceholder } from '../droom/helpers';
import { log } from '../droom/logging';

function totalizer(el) {
  const limit = parseInt(el.dataset.limit);
  const inputs = document.querySelectorAll(el.dataset.inputs);
  const getTotal = (e) => {
    let total = 0;
    inputs.forEach((input) => {
      if (input.value) {
        total += parseInt(input.value);
      }
    });
    el.value = total;
    if (limit && total > limit) {
      el.classList.add("notok")
    } else {
      el.classList.remove("notok")
    }
  }
  inputs.forEach((input) => {
    input.addEventListener('input', getTotal);
  });
  getTotal();
}

/*
  The serial oneliner is generated by default but can be overridden.
  This little editor will preview the default oneliner if no other option is given.
 */
function oneliner(el) {
  const editor = el.querySelector('input[name="serial[pi_description]"]');
  // activePlaceholder(editor);

  const allboxes = el.querySelectorAll('input[type="checkbox"]');
  const tagboxes = el.querySelectorAll('input[type="checkbox"][name="serial[tag_names][]"]');

  const bandbox = el.querySelector('input[type="checkbox"][data-label="Band"]');
  const milbox = el.querySelector('input[type="checkbox"][data-label="Military"]');
  const carbox = el.querySelector('input[type="checkbox"][data-label="Carriage"]');

  const buildDefaultOneliner = (e) => {
    const parts = [];
    if (milbox.checked && bandbox.checked) {
      parts.push("Military band");
    } else if (bandbox.checked) {
      parts.push("Civilian band");
    }
    if (carbox.checked) {
      parts.push("Carriage");
    }
    tagboxes.forEach((tb) => {
      const label = tb.dataset.label;
      if (tb.checked && label) {
        parts.push(label);
      }
    });
    editor.placeholder = parts.join(' + ');
  };

  allboxes.forEach((input) => {
    input.addEventListener('input', buildDefaultOneliner);
  });
}

export {
  totalizer,
  oneliner,
};

